import { useEffect, useState } from "react";
import {
  IconMapPin,
  IconUser,
  IconCake,
  IconClock,
  IconBriefcase2,
  IconClipboardCheck,
  IconEyeOff,
  IconArrowLeft,
  IconMessageCircle,
  IconStar,
  IconStarFilled,
} from "@tabler/icons-react";
import styles from "../TalentProfile.module.css";
import Button from "../../../../components/UI/Button/button";
import { clientMessagesComposeHref, currencyFormat, initialsFor, themeFor } from "../../../../utils/functions";
import moment from "moment";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

const TalentHero = ({
  talent,
  handleRemoveShortlist,
  handleShortlist,
  shortlistLoading,
  isShortlisted,
  hidden
}) => {
  const [shortlisted, setShortlisted] = useState(isShortlisted);
  const navigate = useNavigate();

  useEffect(() => {
    setShortlisted(isShortlisted);
  }, [isShortlisted]);

  const theme = themeFor(talent?.pryRole);

  return (
    <div className={styles.hero}>
      <div className={styles.heroTop}>
        <div
          className={`${styles.mono} ${styles.avatar}`}
          style={{ background: theme.bg, color: theme.fg }}
        >
          {initialsFor(talent?.pryRole) || "AS"}
        </div>
        <div className={styles.backMobileWrap}>
          <Button
            as={Link}
            to="/talent"
            variant="ghost"
            leftIcon={<IconArrowLeft size={15} />}
          >
            Back to Talents
          </Button>
        </div>
      </div>

      <div className={styles.heroId}>
        <div className={styles.heroName}>{talent?.pryRole}</div>
        <div className={styles.heroMeta}>
          <span className={styles.heroMetaItem}>
            <IconMapPin size={16} /> {talent?.currentLocation}
          </span>
          <span className={styles.heroMetaItem}>
            <IconUser size={16} /> {talent?.gender}
          </span>
          <span className={styles.heroMetaItem}>
            <IconCake size={16} />{" "}
            {moment().diff(moment(talent?.dateOfBirth), "years")} years
          </span>
          {/* <span className={styles.heroMetaItem}>
            <IconClock size={16} /> {talent?.jobType}
          </span> */}
        </div>
        <div className={styles.heroBadges}>
          {talent?.workMode?.map((m) => (
            <span key={m} className={`${styles.badge} ${styles.badgeWork}`}>
              <IconBriefcase2 size={13} /> {m}
            </span>
          ))}
          {hidden ? (
            <span className={`${styles.badge} ${styles.badgePsyHidden}`}>
              <IconEyeOff size={13} /> Psychometric hidden
            </span>
          ) : (
            talent?.submittedPsychometricTest && (
              <span className={`${styles.badge} ${styles.badgePsy}`}>
                <IconClipboardCheck size={13} /> Psychometric verified
              </span>
            )
          )}
        </div>
      </div>

      <div className={styles.heroSide}>
        <div>
          <div className={styles.payLabel}>Expected pay</div>
          <div className={styles.pay}>
            &#8358;
            {currencyFormat(
              Number(talent?.desiredCompensation?.lowestAmount ?? 0),
            )}{" "}
            <span> - </span>&#8358;
            {currencyFormat(
              Number(talent?.desiredCompensation?.highestAmount ?? 0),
            )}
          </div>
        </div>
        <div className={styles.heroActions}>
          <Button
            className={`${styles.btnGhostLight} ${shortlisted ? styles.btnGhostLightSaved : ""}`}
            disabled={shortlistLoading}
            loading={shortlistLoading}
            leftIcon={
              shortlisted ? (
                <IconStarFilled size={15} />
              ) : (
                <IconStar size={15} />
              )
            }
            onClick={() => {
              if (shortlisted) {
                handleRemoveShortlist(talent?._id);
              } else {
                handleShortlist(talent?._id);
              }
              setShortlisted((s) => !s);
            }}
          >
            {shortlisted ? "Shortlisted" : "Shortlist"}
          </Button>
          <Button
            variant="primary"
            leftIcon={<IconMessageCircle size={15} />}
            onClick={() => {
              navigate(clientMessagesComposeHref(talent?.email));
            }}
          >
            Message
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TalentHero;
